import {
  IconFile,
  IconFileExcel,
  IconFilePDF,
  IconFileWord,
} from '@bbl-digital/snorre'
import { MimeTypeEnum } from 'shared/models/File'

const getFileIcon = (fileType: string, props?: any) => {
  if (!fileType) return <IconFile {...props} />
  switch (fileType) {
    case MimeTypeEnum.xls:
    case MimeTypeEnum.xlsx:
      return <IconFileExcel {...props} />
    case MimeTypeEnum.pdf:
      return <IconFilePDF {...props} />
    case MimeTypeEnum.doc:
    case MimeTypeEnum.docx:
      return <IconFileWord {...props} />
    default:
      return <IconFile {...props} />
  }
}

export { getFileIcon }
